import { render, staticRenderFns } from "./index.vue?vue&type=template&id=7ee8f307&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\公司文件\\web\\uni-platform\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7ee8f307')) {
      api.createRecord('7ee8f307', component.options)
    } else {
      api.reload('7ee8f307', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=7ee8f307&", function () {
      api.rerender('7ee8f307', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/router/views/production-manage/packing-box-order/index.vue"
export default component.exports